import { Box } from '@mui/material';
import AddressFields from 'components/payment/spreedly/spreedly-card/forms/fields/address-fields.component';
import NameFields from 'components/payment/spreedly/spreedly-card/forms/fields/name-fields.component';
import SpreedlyCheckoutSdkCardFields from './fields/spreedly-checkout-sdk-card-fields.component';

export const SpreedlyCheckoutSdkToast = () => {
  return (
    <Box display="grid" rowGap={theme => theme.spacing(2)}>
      <NameFields />
      <AddressFields />
      <SpreedlyCheckoutSdkCardFields />
    </Box>
  );
};
